import { Header as HeaderWidget } from "@/components/header/index";
import { SectionPage } from "@/components/section-page";
import { LocalizationText } from "@/app/index";
import { useHeaderStyles } from "./header.styles";
import { usePageContextHardware } from "../../context/hardware-context";
import { useMemo } from "react";

import HeaderLogoSvg from "../../static/header-logo.svg?react";

export const Header = () => {
  const { styles } = useHeaderStyles();
  const { currentLang } = usePageContextHardware();

  const breadcrumbItems = useMemo(
    () => [
      {
        title: <LocalizationText value="hardware.header.breadcrumb.home" />,
        href: `/${currentLang}/home`,
      },
      {
        title: <LocalizationText value="hardware.header.breadcrumb.hardware" />,
      },
    ],
    [currentLang],
  );

  return (
    <SectionPage
      classNames={{
        section: styles.section,
        body: styles.body,
      }}
    >
      <HeaderWidget
        icon={<HeaderLogoSvg />}
        title={<LocalizationText value="hardware.header.title" />}
        breadcrumbItems={breadcrumbItems}
      />
    </SectionPage>
  );
};
